var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConversaUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8414 4.21431C16.8414 5.95852 15.4275 7.37247 13.6832 7.37247C13.3029 7.37247 12.9383 7.30525 12.6006 7.18202C13.0986 6.30606 13.3831 5.29281 13.3831 4.21314C13.3831 3.13426 13.099 2.12173 12.6016 1.24621C12.939 1.12324 13.3033 1.05615 13.6832 1.05615C15.4275 1.05615 16.8414 2.47011 16.8414 4.21431Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 15.7944C20.0002 17.5385 17.8573 18.9524 15.241 18.9524C16.0118 18.11 16.5419 17.0524 16.5419 15.7958C16.5419 14.5378 16.0106 13.4792 15.2383 12.6362C17.8546 12.6362 20.0002 14.0501 20.0002 15.7944Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36904 20.0057C11.4389 20.0057 14.7381 18.1205 14.7381 15.7949C14.7381 13.4693 11.4389 11.584 7.36904 11.584C3.29923 11.584 0 13.4693 0 15.7949C0 18.1205 3.29923 20.0057 7.36904 20.0057Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36908 8.42469C9.69469 8.42469 11.58 6.53942 11.58 4.21381C11.58 1.88821 9.69469 0.00292969 7.36908 0.00292969C5.04348 0.00292969 3.1582 1.88821 3.1582 4.21381C3.1582 6.53942 5.04348 8.42469 7.36908 8.42469Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversaUser);
export default __webpack_public_path__ + "static/media/conversaUser.80bb191e11838e654fce32c7a5d309a9.svg";
export { ForwardRef as ReactComponent };